<template>
  <div class="my-8">
    <v-row>
      <v-col cols="8" sm="10">
        <h2 class="section-title">
          {{ $t("Group Sessions") }}
        </h2>
      </v-col>
      <v-col cols="4" sm="2">
        <div class="icons">
          <!-- <v-icon large color="#13a8b1">search</v-icon> -->

          <v-menu
            v-model="filterMenu"
            offset-y
            :close-on-content-click="false"
            :close-on-click="false"
            nudge-width="300"
            offset-x
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                class="filter-btn"
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large color="#13a8b1">filter_alt</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-list>
                <v-list-item>
                  <!-- @click="" -->

                  <v-autocomplete
                    :items="teachers"
                    :label="$t('Teachers')"
                    item-text="name"
                    item-value="id"
                    solo
                    chips
                    multiple
                    v-model="selectedTeachers"
                    @change="filterByTeacher"
                  ></v-autocomplete>
                </v-list-item>
                <v-list-item>
                  <!-- @click="" -->
                  <v-autocomplete
                    :items="subjects"
                    :label="$t('Subjects')"
                    item-text="name"
                    item-value="id"
                    solo
                    multiple
                    chips
                    v-model="selectedSubjects"
                    @change="filterBySubject"
                  ></v-autocomplete>
                </v-list-item>

                <v-btn class="close-menu-btn" @click="filterMenu = false">{{
                  $t("close")
                }}</v-btn>
              </v-list>
            </v-card>
          </v-menu>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="10" class="pa-0" offset-md="1">
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            class="sessions sessions-page groupSessions"
            v-for="(groupSession, index) in groupSessions"
            :key="index"
          >
            <groupSessionCard
              :groupSession="groupSession"
              :isLoggedIn="isLoggedIn"
            >
              <v-btn
                @click.prevent="openDetailsDialog(index)"
                class="primary-btn "
                v-if="groupSession.lessons.length > 1"
                >{{ $t("Reservation & Details") }}</v-btn
              >
              <v-btn
                class="primary-btn "
                @click.prevent="reserve(groupSession.lessons[0].id)"
                v-if="
                  groupSession.lessons.length == 1 &&
                    groupSession.lessons[0].completed == false
                "
                >{{ $t("Reserve") }}</v-btn
              >

              <v-chip
                class="ma-2"
                v-if="
                  groupSession.lessons.length == 1 &&
                    groupSession.lessons[0].completed == true
                "
                color="green"
                text-color="white"
              >
                {{ $t("Completed") }}
              </v-chip>
            </groupSessionCard>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <div class="text-center">
          <v-pagination
            v-model="page"
            color="#ffc382"
            :length="total"
            v-if="total > 1"
          ></v-pagination>
        </div>
      </v-col>
    </v-row>

    <!-- session groups sessions -->
    <groupSessionsReserveDialog
      :sessions="selectedLessons"
      :dialog="DetailsDialog"
      @closeDialog="closeDialog"
    />

    <Snack ref="snack"></Snack>
  </div>
</template>

<script>
import groupSessionsReserveDialog from "../../components/groupSessionsReserveDialog";
import groupSessionCard from "../../components/teacherAppointments/groupSessionCard";

export default {
  name: "groupSessions",
  components: { groupSessionsReserveDialog, groupSessionCard },
  data() {
    return {
      isLoggedIn:
        localStorage.isLoggedIn != undefined &&
        localStorage.isLoggedIn == "true"
          ? true
          : false,
      groupSessions: [],
      selectedLessons: [],
      DetailsDialog: false,
      page: 1,
      total: 1,
      subjects: ["arabic", "english", "physics"],
      filterMenu: false,
      teachers: [],
      selectedSubjects: [],
      selectedTeachers: [],
    };
  },
  watch: {
    page: {
      handler() {
        this.getGroupSessions();
      },
    },
  },
  methods: {
    reserve(singleID) {
      this.$http
        .post(
          this.getApiUrl + "/student/createGroupReservation",
          { teacherSchedulesIds: [singleID] },
          {
            headers: {
              locale: localStorage.locale,
              Authorization: "Bearer " + localStorage.token,
            },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status.error) {
            this.$refs.snack.sendErrorAlert(response.data.status.message);
          } else {
            const reservedList = response.data.data;
            setTimeout(() => {
              window.location.href = "/student/groupPayments/" + reservedList;
            }, 1000);
            this.$refs.snack.sendSuccessAlert(
              this.$i18n.t("Appointment booked successfully")
            );
          }
        });
    },
    closeDialog() {
      this.DetailsDialog = false;
    },
    openDetailsDialog(index) {
      this.selectedLessons = this.groupSessions[index].lessons;
      this.DetailsDialog = true;
    },
    getGroupSessions() {
      this.$http
        .get(
          this.getApiUrl +
            "/getGroupsInHome?page=" +
            this.page +
            "&teachers=" +
            this.selectedTeachers +
            "&subjects=" +
            this.selectedSubjects,
          {
            headers: {
              Authorization: "Bearer " + localStorage.token,
              locale: localStorage.locale,
            },
          }
        )
        .then((response) => {
          if (response.data.status.error == false) {
            this.groupSessions = response.data.data.data;
            this.page = response.data.data.current_page;
            this.total = response.data.data.last_page;
            // this.page = response.data.data.current_page;
            // this.total = response.data.data.last_page;
          }
        });
    },
    filterBySubject() {
      this.page = 1;
      this.getGroupSessions();
    },
    filterByTeacher() {
      this.page = 1;
      this.getGroupSessions();
    },

    getTeachers(selectedSubjects = "") {
      this.$http
        .get(this.getApiUrl + "/getTeachersForStudent", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: localStorage.locale,
          },
        })
        .then((response) => {
          if (response.data.status.error == false) {
            this.teachers = response.data.data;
          }
        });
    },

    getSubjectsForFilter() {
      this.$http
        .get(this.getApiUrl + "/getSubjectsUnderGrade?student_filter=true", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            locale: localStorage.locale,
          },
        })
        .then((response) => {
          if (response.data.status.error == false) {
            this.subjects = response.data.data;
          }
        });
    },
  },
  mounted() {
    this.getGroupSessions();
    this.getTeachers();
    this.getSubjectsForFilter();
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/_variables.scss";

/* group sessions */
.session-card {
  height: 380px !important;
  .teacher-image {
    max-width: 100px;
    max-height: 100px;
    margin: 0 auto !important;
    border-radius: 50%;
  }
}

.filter-btn {
  background-color: transparent !important;
  border: 0;
  box-shadow: unset;
}

.v-menu__content {
  width: 370px !important;
}

.close-menu-btn {
  margin-right: 15px;
  background-color: $second-color !important;
  color: #ffffff;
}
</style>
